import { AgeConfirmRejectModal } from './AgeConfirmRejectModal'
import { withAgeConfirmRejectModal } from './withAgeConfirmRejectModal'

const ConnectedAgeConfirmRejectModal = withAgeConfirmRejectModal(
  AgeConfirmRejectModal
)
export { ConnectedAgeConfirmRejectModal as AgeConfirmRejectModal }
